import styled from "styled-components";
import { generic as sg } from "../../../../../ui/_themes/constants";

export const Wrapper = styled.div`
  position: fixed;
  pointer-events: none;
  top: 50%;
  left: 50%;
  padding: 3.6em;
  border-radius: 0.8em;
  transform: translate(-50%, -50%);
  background: ${sg.activity.backgroundColor};
  z-index: ${sg.layers.activity};
  display: "flex";
  justify-content: center;
  align-items: center;
`;
